import * as actions from './actions'

const catalogPaisesModule = {
    namespaced: true,
    actions,
}

export default catalogPaisesModule
